import { Operation, type TOperation } from '@dbl/core/filter';

/**
 * 切换数值比较运算符时，按业务规则归一化 columnValue：
 * - between / notNull：清空输入
 * - 其它：保留首个有效值到单元素数组
 */
export const resolveValueOnOperationChange = (
  operation: TOperation,
  oldValue: (string | number)[] = [],
): (string | number)[] => {
  if (operation === Operation.Between || operation === Operation.NotNul) {
    return [];
  }
  const value = oldValue[0] ?? oldValue[1];
  return value !== undefined && value !== '' && value !== null ? [value] : [];
};

